import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3745edd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tray" }
const _hoisted_2 = { class: "tray-inner" }

import TrayBlock from "./TrayBlock.vue";
import { allFinalBlockClasses } from "@/utils/block";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allFinalBlockClasses), (blockClass, index) => {
        return (_openBlock(), _createBlock(TrayBlock, {
          key: index,
          "block-class": blockClass
        }, null, 8, ["block-class"]))
      }), 128))
    ])
  ]))
}
}

})